import React from 'react';
import ResetPasswordBlock from '../../components/UI/ResetPasswordBlock';

const ResetPasswordConfirm = () => {
  return <ResetPasswordBlock firstStep={false} />;
};

export default ResetPasswordConfirm;
